import type { SyncMutation, Ticket } from "./types";

/** Re-apply optimistic queue mutations on top of a server ticket snapshot. */
export function withPendingMutations(ticket: Ticket, pending: SyncMutation[]): Ticket {
  const relevant = pending.filter((mutation) => mutation.ticketId === ticket.id);
  if (!relevant.length) return ticket;

  const units = (ticket.units || []).map((unit) => ({ ...unit }));
  for (const mutation of relevant) {
    const unit = units.find((item) => item.id === mutation.unitId);
    if (!unit) continue;
    if (mutation.kind === "assignment") unit.performer = mutation.performer;
    else unit.checkedIn = mutation.delta === 1;
    unit.updatedAt = mutation.createdAt;
    unit.device = mutation.deviceId;
  }

  return {
    ...ticket,
    units,
    checkIns: {
      afternoon: {
        ...ticket.checkIns.afternoon,
        count: units.filter((unit) => unit.session === "afternoon" && unit.checkedIn).length,
      },
      evening: {
        ...ticket.checkIns.evening,
        count: units.filter((unit) => unit.session === "evening" && unit.checkedIn).length,
      },
    },
  };
}
